import React, { Component } from "react";
import * as Constanti from '../../Utils/constants.js';
import '../../style/cards.css';
import '../../style/generic.css';
import moment from "moment";


class CardOne extends Component{
  constructor(props){
    super(props);
}

  render(){
    return (
    <div className="card-in-evidenza" style={{backgroundImage: `linear-gradient(#0d162300, #0d1623e6), url(${Constanti.url_img_new+this.props.thumbnail})`}}>
    <div className="card-info-wrapper">
    <h3 className="h3 element">{this.props.title.length > 52 ? this.props.title.substring(0,52)+"..." : this.props.title}</h3>
    <div className="video-date">{moment(this.props.data).format('DD/MM/YYYY')}</div>
    </div>
    </div>
)
}
}
export default CardOne; 





